import * as React from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import Stack from '@mui/material/Stack'
import { ButtonWithTooltip } from '@sales-center/components'

type Props = {
  onClick?: () => void
  disabled: boolean
  disabledTooltipText?: string
  loading: boolean
}

export function SaveServicesForLaterButton(props: Props) {
  const { onClick, disabled, disabledTooltipText, loading } = props

  return (
    <Stack direction="row">
      <ButtonWithTooltip
        color="primary"
        fullWidth
        variant="outlined"
        onClick={onClick}
        disabled={disabled}
        data-test-id="saveServicesForLaterBtn"
        showTooltip={disabled}
        tooltipTitle={disabledTooltipText}
      >
        {loading ? (
          <CircularProgress size="25px" style={{ position: 'absolute' }} />
        ) : (
          <>Save Services For Later</>
        )}
      </ButtonWithTooltip>
    </Stack>
  )
}
